// extracted by mini-css-extract-plugin
export default {"card":"Content_card__fa2bc","price":"Content_price__zxLf2","row":"Content_row__5XsBu","label":"Content_label__sdUbe"};